export default "__VITE_ASSET__DkJZS8ge__"